import {
  Component,
  Input,
  EventEmitter,
  Output,
  OnDestroy,
  ElementRef,
  HostListener,
  OnInit,
} from '@angular/core';
import { PersonItemModel } from './personItemModel';
import { iOwner, IPerson, IRequester } from './iPerson';
import { peronItemModes } from './peroniItem.enum';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HttpHandlerService } from 'src/app/core/services/http-handler.service';
import { Config } from 'src/app/core/config/api.config';
import { ActivePersonItemService } from './active-person-item-service.service';
import { TranslationModuleEnum } from 'src/app/utils/translation-modules.enum';

@Component({
  selector: 'person-item',
  templateUrl: './personItem.component.html',
  styleUrls: ['./personItem.component.scss'],
  providers: [PersonItemModel],
})
export class PersonItemComponent implements OnInit, OnDestroy {
  currentPeriodId: number;
  private endSub$ = new Subject();
  language: string = this.translate.currentLang;
  @Input() hasUserCard: boolean = true;
  @Input() isUserCardFixed: boolean = false;
  @Input() isTwoWordsOnly: boolean = false;
  translationModulesEnum = TranslationModuleEnum;

  @Input() public set item(item: IPerson) {
    console.log(item)
    this.model.data = item;
    if (item) this.model.setImage(this.model.data.image);
  }
  @Input() public set ownerItem(item: iOwner) {
    this.model.ownerData = item;
    if (item.profileImage) this.model.setImage(this.model.ownerData.profileImage);
  }

  @Input() public set requesterItem(item: IRequester) {
    this.model.data = {
      backgroundColor: '#084d6a',
      image: item?.fileName,
      isActive: true,
      name: this.language == 'en' ? item?.fullName : item?.fullArabicName,
      email: item?.email,
      id: item?.id,
      position: item?.position,
      icon: item?.icon,
      arabicPosition: item?.arabicPosition
    };
    if (item?.fileName) this.model.setImage(item?.fileName);
    else this.model.setImage("");
  }

  @Input() public set creatorData(item) {
    if (item) {
      this.model.data = {
        image: item?.fileName,
        position: item?.position,
        arabicPosition: item?.arabicPosition,
        id: item?.id,
        name: this.language == 'en' ? item?.fullName : item?.fullArabicName,
        email: item?.email,
        isActive: false,
        backgroundColor: '#084d6a',
      };
      this.model.setImage(this.model.data.image);
    }
  }
  @Input() CompMode: peronItemModes = peronItemModes.personMode;
  @Input() isAllowedToChangePhoto: boolean = false;

  @Input() public set backgroundColor(value: string) {
    this.model.data.backgroundColor = value;
  }
  @Input() public set noCursor(value: boolean) {
    this.model.noCursor = value;
  }

  //icon
  @Input() iconType: string = '';
  @Output() logout = new EventEmitter();
  @Output() onResetPassword = new EventEmitter<void>();
  @Output() public onClick: EventEmitter<IPerson> = new EventEmitter<IPerson>();
  displayDropdown: boolean;
  displayUserCard: boolean;

  constructor(
    public model: PersonItemModel,
    private eRef: ElementRef,
    private translate: TranslateService,
    private httpSer: HttpHandlerService,
    private activePersonItemService: ActivePersonItemService // Inject the service
  ) {}

  ngOnInit(): void {
    this.handleLangChange();

    // Subscribe to active component changes
    this.activePersonItemService.getActiveComponent().pipe(takeUntil(this.endSub$)).subscribe(activeComponent => {
      if (activeComponent !== this) {
        this.displayDropdown = false;
        this.displayUserCard = false;
      }
    });
  }

  // handles language change event
  handleLangChange() {
    this.translate.onLangChange.pipe(takeUntil(this.endSub$)).subscribe(() => {
      this.language = this.translate.currentLang;
    });
  }

  getEmployeeYears() {
    this.httpSer
      .get(`${Config.EA.Planning.getEmployeeYears}/${this.model?.data?.id}`)
      .pipe(takeUntil(this.endSub$))
      .subscribe(res => {
        let currentPeriod = res[0]?.periods.find(e => e?.status == 2);
        if (currentPeriod) {
          this.currentPeriodId = currentPeriod?.id;
        } else {
          this.currentPeriodId =
            res[0]?.periods[res[0]?.periods?.length - 1]?.id;
        }
      });
  }

  public get personMode() {
    return this.CompMode === peronItemModes.personMode;
  }

  public get ownerMode() {
    return this.CompMode === peronItemModes.ownerMode;
  }

  public get nameMode() {
    return this.CompMode === peronItemModes.nameMode;
  }

  toggleDropdown() {
    if (this.isAllowedToChangePhoto) {
      this.displayDropdown = !this.displayDropdown;
    }
    // this.getEmployeeYears();
  }

  toggleUserCard(e) {
    e.stopPropagation();
    this.displayUserCard = !this.displayUserCard;
    this.activePersonItemService.setActiveComponent(this); // Set this component as active
    window.dispatchEvent(new Event('resize'));
  }

  onLogout() {
    this.logout.emit();
  }

  openResetPasswordModal() {
    this.onResetPassword.emit();
  }

  ngOnDestroy(): void {
    this.model.endSubs();
    this.endSub$.next(null);
    this.endSub$.complete();
  }

  // close dropdown menu in case clicked outside it
  @HostListener('document:click', ['$event']) onclick(evt: any) {
    if (!this.eRef.nativeElement.contains(evt.target)) {
      this.displayDropdown = false;
      this.displayUserCard = false;
    }
  }
}
